// Pelmeshka palette — light theme; background matches the logo's pure white
export const PELM_BG = '#FFFFFF';                   // page background (logo white)
export const PELM_SURFACE = '#FBF5EC';               // cards, dropdowns, section panels
export const PELM_SURFACE_RAISED = '#F0E3D0';        // hover states, elevated surfaces
export const PELM_BORDER = '#D4B896';                // borders and dividers
export const PELM_CREAM = '#F5E6CA';                 // navbar text, accent surfaces
export const PELM_CREAM_DIM = '#C4A882';             // muted accents
export const PELM_PINK = '#F4A7B9';                  // accent — active/selected items
export const PELM_AMBER = '#C47A30';                 // action buttons
export const PELM_NAVBAR = '#2B1810';                // navbar dark background (contrast header)


// Legacy aliases (deprecated)
export const ASTIROIDS_BLACK = PELM_BG;
export const ASTIROIDS_WHITE = PELM_NAVBAR;
export const ASTIROIDS_GRAY = PELM_SURFACE_RAISED;